var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "inbox-content" } }, [
    _vm.loading
      ? _c("div", { staticClass: "loading" })
      : _vm.answersData.submission
      ? _c("div", [
          _c("div", { staticClass: "content-header" }, [
            _c("h3", [
              _vm._v(
                "Form Submissions ID : " +
                  _vm._s(_vm.answersData.submission._id)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-header" }, [
            _c("h2", [
              _vm._v("Form Yanıtlanma Tarihi: " + _vm._s(_vm.formattedDate)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "header-actions" }, [
              _vm.notReadBtn
                ? _c(
                    "button",
                    {
                      staticClass: "button read-btn",
                      attrs: { disabled: _vm.isUpdating },
                      on: { click: _vm.markAsRead },
                    },
                    [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.isUpdating
                              ? "İşleniyor..."
                              : "Okundu Olarak işaretle"
                          ) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.archiveBTN
                ? _c(
                    "button",
                    {
                      staticClass: "button read-btn",
                      attrs: { disabled: _vm.isUpdating },
                      on: { click: _vm.markAsArchive },
                    },
                    [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.isUpdating ? "İşleniyor..." : "Arşivele") +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-body" },
            [
              _vm.specialAnswer
                ? _c("div", { staticClass: "info-item special-card" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(
                        "Kullanıcı Adı: " +
                          _vm._s(_vm.specialAnswer.value[0].username)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label" }, [
                      _vm._v(
                        "Tam Ad: " + _vm._s(_vm.specialAnswer.value[0].fullName)
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.displayAnswers, function (answer, index) {
                return _c("div", { key: index, staticClass: "info-item" }, [
                  _c("div", { staticClass: "answer-header" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(_vm._s(answer.fieldLabel)),
                    ]),
                    _vm._v(" "),
                    answer.fieldType !== "fileUpload" &&
                    answer.fieldType !== "signature" &&
                    _vm.hasUpdateResponsePermission
                      ? _c(
                          "button",
                          {
                            staticClass: "edit-btn",
                            attrs: { disabled: _vm.isUpdating },
                            on: {
                              click: function ($event) {
                                return _vm.toggleEditMode(answer._id)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-edit" }),
                            _vm._v(
                              "\n                        Düzenle\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.editModeAnswers[answer._id]
                    ? _c("div", { staticClass: "edit-mode" }, [
                        _c(
                          "div",
                          { staticClass: "edit-input-container" },
                          [
                            ["shortText", "longText", "email"].includes(
                              answer.fieldType
                            )
                              ? [
                                  (answer.fieldType === "email"
                                    ? "email"
                                    : "text") === "checkbox" &&
                                  (answer.fieldType === "shortText" ||
                                    answer.fieldType === "email")
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.editValues[answer._id],
                                            expression:
                                              "editValues[answer._id]",
                                          },
                                        ],
                                        staticClass: "edit-input",
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.editValues[answer._id]
                                          )
                                            ? _vm._i(
                                                _vm.editValues[answer._id],
                                                null
                                              ) > -1
                                            : _vm.editValues[answer._id],
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a =
                                                _vm.editValues[answer._id],
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.editValues,
                                                    answer._id,
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.editValues,
                                                    answer._id,
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.editValues,
                                                answer._id,
                                                $$c
                                              )
                                            }
                                          },
                                        },
                                      })
                                    : (answer.fieldType === "email"
                                        ? "email"
                                        : "text") === "radio" &&
                                      (answer.fieldType === "shortText" ||
                                        answer.fieldType === "email")
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.editValues[answer._id],
                                            expression:
                                              "editValues[answer._id]",
                                          },
                                        ],
                                        staticClass: "edit-input",
                                        attrs: { type: "radio" },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.editValues[answer._id],
                                            null
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.editValues,
                                              answer._id,
                                              null
                                            )
                                          },
                                        },
                                      })
                                    : answer.fieldType === "shortText" ||
                                      answer.fieldType === "email"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.editValues[answer._id],
                                            expression:
                                              "editValues[answer._id]",
                                          },
                                        ],
                                        staticClass: "edit-input",
                                        attrs: {
                                          type:
                                            answer.fieldType === "email"
                                              ? "email"
                                              : "text",
                                        },
                                        domProps: {
                                          value: _vm.editValues[answer._id],
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.editValues,
                                              answer._id,
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.editValues[answer._id],
                                            expression:
                                              "editValues[answer._id]",
                                          },
                                        ],
                                        staticClass: "edit-textarea",
                                        attrs: { rows: "3" },
                                        domProps: {
                                          value: _vm.editValues[answer._id],
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.editValues,
                                              answer._id,
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                ]
                              : ["number", "spinner"].includes(answer.fieldType)
                              ? [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editValues[answer._id],
                                        expression: "editValues[answer._id]",
                                      },
                                    ],
                                    staticClass: "edit-input",
                                    attrs: { type: "number" },
                                    domProps: {
                                      value: _vm.editValues[answer._id],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.editValues,
                                          answer._id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              : answer.fieldType === "phone"
                              ? [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editValues[answer._id],
                                        expression: "editValues[answer._id]",
                                      },
                                    ],
                                    staticClass: "edit-input",
                                    attrs: { type: "tel" },
                                    domProps: {
                                      value: _vm.editValues[answer._id],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.editValues,
                                          answer._id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              : answer.fieldType === "address"
                              ? [
                                  _c("div", { staticClass: "address-inputs" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.editValues[
                                              answer._id + "_address1"
                                            ],
                                          expression:
                                            "editValues[answer._id + '_address1']",
                                        },
                                      ],
                                      staticClass: "edit-input",
                                      attrs: { placeholder: "Adres Satırı 1" },
                                      domProps: {
                                        value:
                                          _vm.editValues[
                                            answer._id + "_address1"
                                          ],
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.editValues,
                                            answer._id + "_address1",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.editValues[
                                              answer._id + "_address2"
                                            ],
                                          expression:
                                            "editValues[answer._id + '_address2']",
                                        },
                                      ],
                                      staticClass: "edit-input",
                                      attrs: { placeholder: "Adres Satırı 2" },
                                      domProps: {
                                        value:
                                          _vm.editValues[
                                            answer._id + "_address2"
                                          ],
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.editValues,
                                            answer._id + "_address2",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.editValues[
                                              answer._id + "_district"
                                            ],
                                          expression:
                                            "editValues[answer._id + '_district']",
                                        },
                                      ],
                                      staticClass: "edit-input",
                                      attrs: { placeholder: "İlçe" },
                                      domProps: {
                                        value:
                                          _vm.editValues[
                                            answer._id + "_district"
                                          ],
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.editValues,
                                            answer._id + "_district",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.editValues[
                                              answer._id + "_city"
                                            ],
                                          expression:
                                            "editValues[answer._id + '_city']",
                                        },
                                      ],
                                      staticClass: "edit-input",
                                      attrs: { placeholder: "Şehir" },
                                      domProps: {
                                        value:
                                          _vm.editValues[answer._id + "_city"],
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.editValues,
                                            answer._id + "_city",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.editValues[
                                              answer._id + "_postal"
                                            ],
                                          expression:
                                            "editValues[answer._id + '_postal']",
                                        },
                                      ],
                                      staticClass: "edit-input",
                                      attrs: { placeholder: "Posta Kodu" },
                                      domProps: {
                                        value:
                                          _vm.editValues[
                                            answer._id + "_postal"
                                          ],
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.editValues,
                                            answer._id + "_postal",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]
                              : answer.fieldType === "fullName"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "fullname-inputs" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.editValues[
                                                answer._id + "_firstName"
                                              ],
                                            expression:
                                              "editValues[answer._id + '_firstName']",
                                          },
                                        ],
                                        staticClass: "edit-input",
                                        attrs: { placeholder: "Ad" },
                                        domProps: {
                                          value:
                                            _vm.editValues[
                                              answer._id + "_firstName"
                                            ],
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.editValues,
                                              answer._id + "_firstName",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.editValues[
                                                answer._id + "_lastName"
                                              ],
                                            expression:
                                              "editValues[answer._id + '_lastName']",
                                          },
                                        ],
                                        staticClass: "edit-input",
                                        attrs: { placeholder: "Soyad" },
                                        domProps: {
                                          value:
                                            _vm.editValues[
                                              answer._id + "_lastName"
                                            ],
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.editValues,
                                              answer._id + "_lastName",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              : answer.fieldType === "starRating"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "star-rating-edit" },
                                    _vm._l(5, function (star) {
                                      return _c(
                                        "span",
                                        {
                                          key: star,
                                          staticClass: "star",
                                          class: {
                                            active:
                                              star <=
                                              _vm.editValues[answer._id],
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.editValues[answer._id] = star
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    ★\n                                "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              : answer.fieldType === "ratingScale"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "rating-scale-edit" },
                                    _vm._l(5, function (rating) {
                                      return _c(
                                        "span",
                                        {
                                          key: rating,
                                          staticClass: "rating-number",
                                          class: {
                                            active:
                                              rating ===
                                              _vm.editValues[answer._id],
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.editValues[answer._id] =
                                                rating
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(rating) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              : ["singleChoice", "dropDownList"].includes(
                                  answer.fieldType
                                )
                              ? [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editValues[answer._id],
                                        expression: "editValues[answer._id]",
                                      },
                                    ],
                                    staticClass: "edit-input",
                                    attrs: {
                                      type: "text",
                                      placeholder:
                                        "Mevcut değer: " +
                                        (answer.value && answer.value[0]
                                          ? answer.value[0]
                                          : ""),
                                    },
                                    domProps: {
                                      value: _vm.editValues[answer._id],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.editValues,
                                          answer._id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              : answer.fieldType === "multipleSelection"
                              ? [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editValues[answer._id],
                                        expression: "editValues[answer._id]",
                                      },
                                    ],
                                    staticClass: "edit-input",
                                    attrs: {
                                      type: "text",
                                      placeholder:
                                        "Mevcut değer: " +
                                        (answer.value && answer.value[0]
                                          ? answer.value[0]
                                          : ""),
                                    },
                                    domProps: {
                                      value: _vm.editValues[answer._id],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.editValues,
                                          answer._id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              : answer.fieldType === "datePicker"
                              ? [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editValues[answer._id],
                                        expression: "editValues[answer._id]",
                                      },
                                    ],
                                    staticClass: "edit-input",
                                    attrs: { type: "date" },
                                    domProps: {
                                      value: _vm.editValues[answer._id],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.editValues,
                                          answer._id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              : answer.fieldType === "hour"
                              ? [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editValues[answer._id],
                                        expression: "editValues[answer._id]",
                                      },
                                    ],
                                    staticClass: "edit-input",
                                    attrs: { type: "time" },
                                    domProps: {
                                      value: _vm.editValues[answer._id],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.editValues,
                                          answer._id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              : answer.fieldType === "signature"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "signature-edit-container" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "signature-current" },
                                        [
                                          answer.value
                                            ? _c("img", {
                                                staticClass:
                                                  "current-signature-image",
                                                attrs: {
                                                  src: answer.value,
                                                  alt: "Mevcut İmza",
                                                },
                                                on: {
                                                  error:
                                                    _vm.onSignatureImageError,
                                                  load: _vm.onSignatureImageLoad,
                                                },
                                              })
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "no-current-signature",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-signature",
                                                  }),
                                                  _vm._v(
                                                    "\n                                        Mevcut imza yok\n                                    "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._m(0, true),
                                    ]
                                  ),
                                ]
                              : [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editValues[answer._id],
                                        expression: "editValues[answer._id]",
                                      },
                                    ],
                                    staticClass: "edit-input",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.editValues[answer._id],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.editValues,
                                          answer._id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "edit-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass: "save-btn",
                              attrs: { disabled: _vm.isUpdating },
                              on: {
                                click: function ($event) {
                                  return _vm.saveAnswer(answer)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fas fa-save" }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.isUpdating
                                      ? "Kaydediliyor..."
                                      : "Kaydet"
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "cancel-btn",
                              attrs: { disabled: _vm.isUpdating },
                              on: {
                                click: function ($event) {
                                  return _vm.cancelEdit(answer._id)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fas fa-times" }),
                              _vm._v(
                                "\n                            İptal\n                        "
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _c(
                        "span",
                        { staticClass: "value" },
                        [
                          answer.fieldType === "fileUpload"
                            ? [
                                _c(
                                  "ul",
                                  [
                                    _c(
                                      "viewer",
                                      { attrs: { options: { inline: false } } },
                                      _vm._l(answer.value, function (url, idx) {
                                        return _c(
                                          "li",
                                          {
                                            key: idx,
                                            staticClass: "file-list-item",
                                          },
                                          [
                                            url.endsWith(".pdf")
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "pdf-file",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openFile(
                                                            url
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "svg",
                                                        {
                                                          attrs: {
                                                            width: "24",
                                                            height: "24",
                                                            viewBox:
                                                              "0 0 24 24",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              d: "M12 0L8.59 3.41 11.17 6H0v2h11.17l-2.58 2.59L12 12l6-6-6-6z",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                                            PDF File\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : url.endsWith(".svg")
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "svg-file",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openFile(
                                                            url
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "svg",
                                                        {
                                                          attrs: {
                                                            width: "24",
                                                            height: "24",
                                                            viewBox:
                                                              "0 0 24 24",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              d: "M12 0L8.59 3.41 11.17 6H0v2h11.17l-2.58 2.59L12 12l6-6-6-6z",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                                            SVG File\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.prependHttps(
                                                        url
                                                      ),
                                                      alt: "Image " + (idx + 1),
                                                    },
                                                  }),
                                                ],
                                          ],
                                          2
                                        )
                                      }),
                                      0
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : answer.fieldType === "signature"
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "signature-display" },
                                  [
                                    answer.value
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "signature-image-container",
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "signature-image",
                                              attrs: {
                                                src: answer.value,
                                                alt: "İmza",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openSignatureModal(
                                                    answer.value
                                                  )
                                                },
                                                error:
                                                  _vm.onSignatureImageError,
                                                load: _vm.onSignatureImageLoad,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "signature-actions",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "signature-view-btn",
                                                    attrs: {
                                                      title: "İmzayı büyüt",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openSignatureModal(
                                                          answer.value
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-expand",
                                                    }),
                                                    _vm._v(
                                                      "\n                                        Büyüt\n                                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "signature-download-btn",
                                                    attrs: {
                                                      title: "İmzayı indir",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.downloadSignature(
                                                          answer.value,
                                                          answer.fieldLabel
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-download",
                                                    }),
                                                    _vm._v(
                                                      "\n                                        İndir\n                                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "no-signature" },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-signature",
                                            }),
                                            _vm._v(
                                              "\n                                İmza bulunamadı\n                            "
                                            ),
                                          ]
                                        ),
                                  ]
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.getAnswerValue(answer)) +
                                    "\n                    "
                                ),
                              ],
                        ],
                        2
                      ),
                ])
              }),
            ],
            2
          ),
        ])
      : _c("div", { staticClass: "no-data" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("form.noSubmissionData")) + "\n    "
          ),
        ]),
    _vm._v(" "),
    _vm.signatureModalVisible
      ? _c(
          "div",
          {
            staticClass: "signature-modal-overlay",
            on: { click: _vm.closeSignatureModal },
          },
          [
            _c(
              "div",
              {
                staticClass: "signature-modal",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "signature-modal-header" }, [
                  _c("h3", [_vm._v("İmza Görüntüle")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close-btn",
                      on: { click: _vm.closeSignatureModal },
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "signature-modal-body" }, [
                  _c("img", {
                    staticClass: "signature-modal-image",
                    attrs: { src: _vm.selectedSignature, alt: "İmza" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "signature-modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "download-btn",
                      on: {
                        click: function ($event) {
                          return _vm.downloadSignature(
                            _vm.selectedSignature,
                            "Imza"
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-download" }),
                      _vm._v("\n                    İndir\n                "),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "signature-edit-note" }, [
      _c("i", { staticClass: "fas fa-info-circle" }),
      _vm._v(
        "\n                                    İmza düzenlemesi visitor panelinden yapılabilir\n                                "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }